import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MainMenuModule } from '../main-menu/main-menu.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoriesModule } from '../categories/categories.module';
import { AppRoutingModule } from '../../app-routing.module';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { ParentCardComponent } from './parent-card.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ParentCardComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    MatSliderModule,
    MainMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    CategoriesModule,
    MatCardModule,
    MatDividerModule,
    GoogleMapsModule,
    MatTooltipModule
  ],
  exports: [
    ParentCardComponent
  ]
})
export class ParentCardModule { }